<template>
  <div class="gongde-box-pay-success-container">
    <van-nav-bar class="gongde-box-pay-success-nav-bar" title="功德箱" left-arrow @click-left="handleBack">
      <template #left>
        <van-icon name="arrow-left" size="18" color="#333" />
      </template>
    </van-nav-bar>
    <div class="gongde-box-pay-success-content">
      <img
        class="cover"
        src="https://hk-public.tengzhihh.com/image/0340d12e241c3556154f06b98bf2e6f0-135x135.png"
        alt=""
      />
      <div class="gongde-box-pay-success-title" v-if="gongde">感恩布施</div>
      <div class="gongde-box-pay-success-gongde">
        功德值
        <span class="gongde-box-pay-success-gongde-value">+{{ gongde }}</span>
      </div>
      <div class="gongde-box-pay-success-tips" v-if="gongde">您的善心已送达，愿吉祥安康</div>
      <div class="gongde-box-pay-success-explore">探索更多</div>
      <div class="gongde-box-pay-success-explore-item">
        <img src="https://hk-public.tengzhihh.com/image/02b65d7dc9932c7fbbab2fb2602a1deb-60x60.png" alt="" />
        <div class="gongde-box-pay-success-explore-item-title">再填善款，种植莲因</div>
        <div class="gongde-box-pay-success-explore-item-button" @click="handleExplore">去布施</div>
      </div>
    </div>
  </div>
</template>

<script>
import { orderDetailMin } from '@/api/order';

export default {
  data() {
    return {
      serial_id: '',
      gongde: 0,

      // 0 :'未支付',  1 '已支付,待发货', 2: '已取消', 3 : '已退款',  4 : '部分退款',  5 : '已发货，待收货', 6: '已完成',
      statusMap: {
        0: '订单未支付',
        1: '订单已支付,待发货',
        2: '订单已取消',
        3: '订单已退款',
        4: '订单部分退款',
        5: '订单已发货，待收货',
        6: '订单已完成',
      },
    };
  },
  async mounted() {
    const { order_id } = this.parseQueryParams();
    if (order_id) {
      const { code, data } = await orderDetailMin({ order_id });
      if (code === 0) {
        this.serial_id = data.order.serial_id || '';
        if (data.order.status === 6) {
          this.gongde = data.order.fu_de;
        } else {
          this.$toast(this.statusMap[data.order.status]);
        }
      } else {
        this.$toast(msg);
      }
    } else {
      this.$toast('未查询到订单信息');
    }
  },
  methods: {
    handleBack() {
      this.$router.go(-1);
    },
    handleExplore() {
      if (this.serial_id) {
        this.$router.push({
          name: 'gongde-box-index',
          query: {
            serial_id: this.serial_id,
          },
        });
      } else {
        this.$router.push({ name: 'index' });
      }
    },

    parseQueryParams(search = location.search, convertNumbers = true) {
      // 移除开头的问号
      let searchString = search.charAt(0) === '?' ? search.substring(1) : search;

      // 处理空字符串情况
      if (!searchString) {
        return {};
      }

      // 检查是否整个查询字符串被编码
      const isFullyEncoded = searchString.includes('%3D') && searchString.includes('%26');

      let queryObject = {};

      if (isFullyEncoded) {
        // 对整个查询字符串解码
        const decodedString = decodeURIComponent(searchString);

        // 检查解码后的字符串是否为标准查询字符串格式
        if (decodedString.includes('=') && decodedString.includes('&')) {
          const pairs = decodedString.split('&');
          pairs.forEach(pair => {
            if (pair.includes('=')) {
              const [key, value] = pair.split('=');
              queryObject[key] = convertNumbers && /^\d+$/.test(value) ? Number(value) : value;
            }
          });
        } else {
          // 如果解码后仍不是标准格式，则作为单一参数处理
          queryObject = { query: decodedString };
        }
      } else {
        // 标准格式的查询参数
        const searchParams = new URLSearchParams(searchString);
        searchParams.forEach((value, key) => {
          queryObject[key] = convertNumbers && /^\d+$/.test(value) ? Number(value) : value;
        });
      }

      return queryObject;
    },
  },
};
</script>
<style lang="less" scoped>
.gongde-box-pay-success-container {
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  background-color: #f8f8f8;

  display: flex;
  flex-direction: column;

  .gongde-box-pay-success-nav-bar {
    flex-shrink: 0;
  }
  .gongde-box-pay-success-content {
    flex-grow: 1;
    overflow-y: auto;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 0 15px;

    .cover {
      margin-top: 30px;
      width: 138px;
      height: 138px;
    }

    .gongde-box-pay-success-title {
      font-size: 18.5px;
      font-weight: 500;
      color: #f2a70b;
      font-family: Source Han Sans CN, Source Han Sans CN;
    }

    .gongde-box-pay-success-gongde {
      margin-top: 20px;
      font-family: Source Han Sans CN, Source Han Sans CN;
      font-weight: 500;
      font-size: 24.5px;
      color: #333;

      .gongde-box-pay-success-gongde-value {
        color: #f87a1b;
      }
    }

    .gongde-box-pay-success-tips {
      margin-top: 10px;
      font-family: Source Han Sans CN, Source Han Sans CN;
      font-weight: 400;
      font-size: 14.5px;
      color: rgba(0, 0, 0, 0.65);
    }
    .gongde-box-pay-success-explore {
      margin-top: 30px;
      width: 100%;
      font-family: Source Han Sans CN, Source Han Sans CN;
      font-weight: 400;
      font-size: 16.5px;
      color: rgba(0, 0, 0, 0.85);
      text-align: left;
      margin-bottom: 10px;
    }

    .gongde-box-pay-success-explore-item {
      width: 100%;
      height: 78px;
      background: #ffefd9;
      border-radius: 8px;
      display: flex;
      align-items: center;
      padding: 8px;
      display: flex;
      gap: 15px;
      align-items: center;
      box-sizing: border-box;

      img {
        flex-shrink: 0;
        display: inline-block;
        width: 60px;
        height: 60px;
        margin: 0;
      }

      .gongde-box-pay-success-explore-item-title {
        font-family: Source Han Sans CN, Source Han Sans CN;
        font-weight: 500;
        font-size: 16.5px;
        color: #a96e13;
        text-align: left;
      }

      .gongde-box-pay-success-explore-item-button {
        flex-shrink: 0;
        width: 71.5px;
        height: 30.5px;
        background: #f87a1b;
        border-radius: 10px;
        display: flex;
        align-items: center;
        justify-content: center;
        font-family: Source Han Sans CN, Source Han Sans CN;
        font-weight: 500;
        font-size: 14.5px;
        color: rgba(255, 255, 255, 0.9);
      }
    }
  }
}
</style>
